export default "__VITE_ASSET__2uccP_Pp__"